<template>
  <div id="jobDetails">
    <div class="detail_container">
      <div class="detail_title_info">
        <div class="job_info_container">
          <div class="job_info">{{ list.positionName }}</div>
          <div class="salary_info">{{ list.payRange }}万</div>
        </div>
        <div class="base_info">
          <div class="city">
            <img src="../../../assets/hr/city_icon.png" alt="" class="base_info_icon">
            <div>{{ list.workAddr }}</div>
          </div>
          <div class="year">
            <img src="../../../assets/hr/year_icon.png" alt="" class="base_info_icon">
            <div>{{ list.workExperience }}年</div>
          </div>
          <div class="education">
            <img src="../../../assets/hr/education_icon.png" alt="" class="base_info_icon">
            <div>{{ list.education }}</div>
          </div>
        </div>
      </div>
      <div class="detail_recruit_info">
        <div style="display: flex;justify-content: space-between; align-items: center;">
          <div class="content_title_info">
            <div class="title_icon"></div>
            <div class="title_text">岗位信息</div>
          </div>
          <div class="title_right_info">
            <div v-if="expansionAndPutAwayFlag" @click="expansionAndPutAway(false)">收起 <i class="el-icon-arrow-down"></i></div>
            <div v-else @click="expansionAndPutAway(true)">展开 <i class="el-icon-arrow-up"></i></div>
          </div>
        </div>
        <div class="detail_text_info" v-if="expansionAndPutAwayFlag">
          <div class="detail_content_info">
            <div class="job_detail_info">
              <div class="content_title_info">
                <!-- <div class="title_icon"></div> -->
                <div class="title_text">岗位职责</div>
              </div>
              <div class="detail_text_info">
                <div v-for="(text, index) in position_statement_list" :key="index">{{ text }}</div>
              </div>
            </div>
            <div class="job_detail_info">
              <div class="content_title_info">
                <!-- <div class="title_icon"></div> -->
                <div class="title_text">岗位要求</div>
              </div>
              <div class="detail_text_info">
                <div v-for="(text, index) in job_requirements_list" :key="index">{{ text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail_recruit_info">
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">被推荐人信息</div>
        </div>
        <el-form ref="form" label-width="50px" label-position="left">
          <el-form-item label="姓名：">
            <div class="from_info">{{ list.name }}</div>
          </el-form-item>
          <el-form-item label="电话：">
            <div class="from_info">{{ list.tel }}</div>
          </el-form-item>
          <el-form-item label="邮箱：">
            <div class="from_info">{{ list.email }}</div>
          </el-form-item>
          <el-form-item label="简历：" v-for="(item, i) in list.fileList" :key="i">
            <img src="../../../assets/hr/resume_icon.png" alt="" class="resume_icon">
            <div>{{ item.fileName }}</div>
            <!-- <van-uploader :after-read="onRead" class="upload_resume">
              <div v-if="fileName">{{ fileName }} <van-icon name="edit" /></div>
              <div v-else>上传简历 <van-icon name="edit" /></div>
            </van-uploader>
            <van-icon v-if="fileName" name="close" @click="closeFile" /> -->
          </el-form-item>
        </el-form>
        <div class="correlation_info">
          <div>推荐人：{{ list.operateName }}</div>
          <div>关系：{{ list.relation }}</div>
        </div>
      </div>
      <div class="detail_recruit_info">
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">投递进度</div>
        </div>
        <el-steps direction="vertical" :active="active" finish-status="success" :space="88">
          
          <el-step :title="item.itemName" v-for="(item, i) in list.items" :key="i">
            <slot slot="description">
              <p v-if="item.hrName">面试官：{{ item.hrName }}</p>
              <p>{{ item.itemName == '投递成功' ? '' : item.itemName }} {{ item.itemTime }}</p>
            </slot>
          </el-step>
        </el-steps>
      </div>
      <div class="btn_info">
        <van-button plain type="danger" class="out" @click="outClick">淘汰</van-button>
        <van-button plain type="primary" class="reexamine" @click="reexamineClick">复试</van-button>
        <van-button type="success" class="pass" @click="passClick">通过</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/apis/inside'
export default {
  data() {
    return {
      list: JSON.parse(this.$route.query.list),
      position_statement_list: [],
      job_requirements_list: [],
      expansionAndPutAwayFlag: false,
      active: 0,
    }
  },
  mounted() {
    this.selectResumeHrDetail()
  },
  methods: {
    //获取面试详情
    selectResumeHrDetail() {
      api.selectResumeHrDetail({
        recordUuid: this.list.recordUuid,
      }).then((res) => {
        if (res.code == 200) {
          this.list = res.data
          this.active = res.data.items.length
          this.position_statement_list = this.list.positionStatement && this.list.positionStatement.split('<br>')
          this.job_requirements_list = this.list.jobRequirements && this.list.jobRequirements.split('<br>')
        }
      })
    },
    expansionAndPutAway(flag) {
      this.expansionAndPutAwayFlag = flag
    },
    // onRead(file) {
    //   this.fileName = file.file.name.split('.')[0]
    //   this.fileUrl = file.file.content
    // },
    // closeFile() {
    //   this.fileName = ''
    //   this.fileUrl = ''
    // },
    //跳转淘汰页面
    outClick() {
      this.$router.push({
        path: '/HR/outInterview',
        query: {
          list: JSON.stringify(this.list),
        },
      })
    },
    //跳转复试页面
    reexamineClick() {
      this.$router.push({
        path: '/HR/secondInterview',
        query: {
          list: JSON.stringify(this.list),
        },
      })
    },
    //跳转通过页面
    passClick() {
      this.$router.push({
        path: '/HR/passInterview',
        query: {
          list: JSON.stringify(this.list),
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #jobDetails {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #jobDetails {
    width: 276px * $zoom;
  }
}
#jobDetails {
  font-size: 16px * $zoom;
  position: relative;
  .detail_container {
    width: 100%;
    min-height: 100vh;
    // padding-bottom: 136px;
    background: #F7F9FA;
    .detail_title_info {
      padding: 36px 32px;
      background: #fff;
      .job_info_container {
        display: flex;
        justify-content: space-between;
        .job_info{
          font-size: 36px;
          font-weight: bold;
          color: #282B32;
        }
        .salary_info {
          font-size: 36px;
          font-weight: bold;
          color: #4EA27C;
        }
      }
      .base_info {
        overflow: hidden;
        margin-top: 20px;
        color: #969B9E;
        font-size: 28px;
        font-weight: bold;
        &>div {
          float: left;
          padding-right: 28px;
        }
        .city {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 26px;
            height: 32px;
            margin-right: 12px;
          }
        }
        .year {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 28px;
            height: 28px;
            margin-right: 12px;
          }
        }
        .education {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 36px;
            height: 30px;
            margin-right: 12px;
          }
        }
      }
      .arrive_time_info {
        margin-top: 40px;
        color: #666666;
        font-size: 28px;
      }
    }
    .detail_recruit_info {
      margin-top: 24px;
      padding: 32px;
      background: #fff;
      font-size: 30px;
      .title_right_info {
        color: #969B9E;
        font-size: 30px;
        cursor: pointer;
      }
      .content_title_info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .title_icon {
          width: 8px;
          height: 32px;
          margin-right: 20px;
          background: #4EA27C;
          border-radius: 4px;
        }
        .title_text {
          font-size: 32px;
          font-weight: bold;
          color: #282B32;
        }
      }
      ::v-deep .el-form {
        margin-bottom: 40px;
        padding: 30px 0 40px;
        border-bottom: 2px solid #F1F1F1;
        font-size: 30px;
        .el-form-item {
          &:last-child {
            margin: 0;
          }
          .el-form-item__label {
            padding: 0;
            line-height: 42px;
            color: #666666;
          }
          .el-form-item__content {
            display: flex;
            position: relative;
            line-height: 42px;
            .from_info {
              color: #282B32;
            }
            .upload_resume {
              color: #4EA27C;
            }
            .van-icon-close {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              color: #4EA27C;
            }
            .resume_icon {
              width: 32px;
              height: 36px;
              margin-right: 20px;
            }
          }
        }
      }
      .correlation_info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #969B9E;
      }
      .detail_text_info {
        text-overflow:ellipsis;
        margin-top: 20px;
        color: #666666;
        font-size: 30px;
        line-height: 56px;
      }
    }
    .btn_info {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 32px;
      .van-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 124px;
        height: 52px;
        margin-left: 40px;
        background: #fff;
        border: 2px solid #E22121;
        border-radius: 8px;
      }
      .reexamine {
        border: 2px solid #5DD5C9;
        color: #5DD5C9;
      }
      .pass {
        background: #4EA27C;
        border: 2px solid #4EA27C;
        color: #fff;
      }
    }
  }
  ::v-deep .el-steps {
    padding-top: 30px;
    .el-step {
      .el-step__title.is-success,
      .el-step__title.is-process {
        color: #282B32;
        font-weight: 600;
        font-size: 30px;
      }
      .el-step__title.is-wait {
        font-weight: 500;
        color: #969B9E;
        font-size: 30px;
      }
      .el-step__description.is-success,
      .el-step__description.is-process {
        color: #666666;
        font-size: 28px;
      }
      .el-step__description.is-wait {
        font-size: 28px;
        color: #969B9E;
      }
      .el-step__head.is-success,
      .el-step__head.is-process {
        border-color: #4EA27C;
        color: #4EA27C;
      }
      .el-step__head.is-success {
        .el-step__icon.is-text {
          background: #4EA27C;
          .el-step__icon-inner.is-status {
            z-index: 9;
            color: #fff;
          }
        }
      }
    }
  }
}

</style>